<style lang="scss">
.reminder {
  @apply border-orange-300 border-2 rounded-md p-2 bg-orange-100 w-full float-left mt-2 mb-8 box-border #{!important};
  p>small,  p>strong {
    @apply text-orange-300 font-bold uppercase;
  }
  p>small {
    @apply border-orange-300 flex justify-center items-center font-bold border-2 rounded-full w-3 h-3 mr-1 text-center float-left;
  }
  p {
    @apply text-sm mb-2;
  }
  p>span {
    @apply bg-gray-500 font-bold bg-opacity-25 text-center p-2 box-border block;
  }
  p>i {
    @apply text-orange-500 float-right cursor-pointer;
  }
}
</style>

<template>
  <transition name="fade">
    <div class="reminder" v-if="!hide">
      <p><small>!</small><strong>Lembrete</strong> <i @click="hide = true" class="icon icon-cross"></i></p>
      <p>Você possui um atendimento agendado com este paciente para:</p>
      <p><span>{{ returnAppointment }}</span></p>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      hide: false
    }
  },
  props: {
    nextAppointment: {
      type: Object,
      default: null
    }
  },
  computed: {
    returnAppointment () {
      const dateObj = this.$moment(this.nextAppointment.appointment_start)
      const day = this.$moment().isSame(this.nextAppointment.appointment_start, 'day') ? 'hoje' : dateObj.format('DD/MM')
      const hour = dateObj.format('HH:mm')
      return `${day}, às ${hour}`
    }
  }
}
</script>
